import { Fragment } from 'react';

import { docMarkdown, tachDam } from '../../nghiep-vu/tom-tat';

function Dong({ chu }: { chu: string }) {
  return (
    <>
      {tachDam(chu).map((p, i) =>
        p.dam ? (
          <strong key={i} className="font-semibold text-content-primary">
            {p.chu}
          </strong>
        ) : (
          <Fragment key={i}>{p.chu}</Fragment>
        ),
      )}
    </>
  );
}

/**
 * Bản tóm tắt AI dạng Markdown (đoạn, tiêu đề, danh sách, chữ đậm). Dựng thành phần React, không
 * `innerHTML`, nên chữ do AI sinh không chạy được mã.
 */
export function TomTatMarkdown({ van }: { van: string }) {
  return (
    <div className="space-y-2 text-sm leading-relaxed text-content-secondary">
      {docMarkdown(van).map((k, i) => {
        if (k.kieu === 'tieu-de') {
          return (
            <p key={i} className="text-sm font-semibold text-content-primary">
              <Dong chu={k.chu} />
            </p>
          );
        }
        if (k.kieu === 'doan') {
          return (
            <p key={i}>
              <Dong chu={k.chu} />
            </p>
          );
        }
        const Ds = k.thuTu ? 'ol' : 'ul';
        return (
          <Ds key={i} className={k.thuTu ? 'list-decimal space-y-0.5 pl-5' : 'list-disc space-y-0.5 pl-5'}>
            {k.muc.map((m, j) => (
              <li key={j}>
                <Dong chu={m} />
              </li>
            ))}
          </Ds>
        );
      })}
    </div>
  );
}
